import { QAV } from 'qunar-react-native';
export const qav = (json: object, debug: any = false) => {
    try {
        const message = `CARD_ENTRANCE_START####${JSON.stringify(json)}####CARD_ENTRANCE_END`;
        if (debug) {
            console.warn(message);
        }
        if (QAV.logMsg) {
            QAV.logMsg(message);
        } else {
            QAV.log && QAV.log('cmn_order_rn', message);
        }
    } catch (e) {
        console.log(e);
    }
};
